import { UseCaseFormData } from "./UseCaseContributePage";

export type StepValidator = (formData: UseCaseFormData) => boolean;

// Schema limits from userusecases.schema.json
export const SCHEMA_LIMITS = {
  name: 120,
  shortDescription: 500,
  categoriesMax: 10,
  recommendedAudienceMax: 10,
  associatedToolIdsMax: 20,
  impactBefore: 800,
  impactAfter: 800,
  stepsMax: 30,
  stepTitle: 200,
  stepExpectedResult: 500,
  stepCodeSnippet: 4000,
  stepPrompt: 4000,
  stepLearning: 1000,
  prerequisiteItem: 200,
  prerequisitesMax: 20,
  learnMoreLinksMax: 10,
  learnMoreTitle: 120,
  learnMoreUrl: 500,
};

export const STEP_VALIDATORS: Record<string, StepValidator> = {
  basicInformation: (fd) =>
    fd.title.trim().length > 0 &&
    fd.title.length <= SCHEMA_LIMITS.name &&
    fd.shortDescription.trim().length > 0 &&
    fd.shortDescription.length <= SCHEMA_LIMITS.shortDescription &&
    fd.toolsUsed.length > 0 &&
    fd.toolsUsed.length <= SCHEMA_LIMITS.associatedToolIdsMax &&
    fd.categories.length > 0 &&
    fd.categories.length <= SCHEMA_LIMITS.categoriesMax,

  workflow: (fd) =>
    fd.beforeWorkflow.trim().length > 0 &&
    fd.beforeWorkflow.length <= SCHEMA_LIMITS.impactBefore &&
    fd.afterWorkflow.trim().length > 0 &&
    fd.afterWorkflow.length <= SCHEMA_LIMITS.impactAfter &&
    fd.steps.length > 0 &&
    fd.steps.length <= SCHEMA_LIMITS.stepsMax &&
    fd.steps.every(
      (s: { title: string; expectedResult: string; codeSnippet?: string; prompt?: string; learning?: string }) =>
        s.title.trim().length > 0 &&
        s.title.length <= SCHEMA_LIMITS.stepTitle &&
        (!s.expectedResult || s.expectedResult.length <= SCHEMA_LIMITS.stepExpectedResult) &&
        (!s.codeSnippet || s.codeSnippet.length <= SCHEMA_LIMITS.stepCodeSnippet) &&
        (!s.prompt || s.prompt.length <= SCHEMA_LIMITS.stepPrompt) &&
        (!s.learning || s.learning.length <= SCHEMA_LIMITS.stepLearning)
    ),

  audienceAndImpact: (fd) =>
    fd.targetAudience.length > 0 &&
    fd.targetAudience.length <= SCHEMA_LIMITS.recommendedAudienceMax &&
    fd.difficultyLevel !== "" &&
    fd.impactIndicators.length > 0 &&
    (!fd.impactIndicators.includes("OTHER") || fd.otherImpactIndicator.trim() !== ""),

  additionalResources: (fd) =>
    fd.learnMoreLinks.filter((l) => l.url.trim()).length <= SCHEMA_LIMITS.learnMoreLinksMax &&
    fd.learnMoreLinks.every(
      (l) => l.title.length <= SCHEMA_LIMITS.learnMoreTitle && l.url.length <= SCHEMA_LIMITS.learnMoreUrl
    ),
};
